import { render, staticRenderFns } from "./MicroserviceButton.vue?vue&type=template&id=556b8e50&scoped=true&lang=pug&"
import script from "./MicroserviceButton.vue?vue&type=script&lang=js&"
export * from "./MicroserviceButton.vue?vue&type=script&lang=js&"
import style0 from "./MicroserviceButton.vue?vue&type=style&index=0&id=556b8e50&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556b8e50",
  null
  
)

/* custom blocks */
import block0 from "./MicroserviceButton.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports